/**
 * 관리자 주문(매출) 관리 API 서비스
 */

import { apiGet, apiPut } from "./apiClient";

/**
 * 주문(매출) 목록 조회 (페이지네이션)
 * @param {number} page - 페이지 번호 (0부터 시작)
 * @param {number} size - 페이지 크기
 */
export const getOrderList = async (page = 0, size = 10) => {
  try {
    const response = await apiGet(`/admin/order?page=${page}&size=${size}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "주문 목록을 불러오는데 실패했습니다.",
      };
    }
  } catch (error) {
    console.error("주문 목록 조회 중 오류:", error);
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 주문(매출) 상세 조회
 * @param {string} orderCode - 주문 코드
 */
export const getOrderDetail = async (orderCode) => {
  try {
    const response = await apiGet(`/admin/order/${orderCode}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "주문 상세 정보를 불러오는데 실패했습니다.",
      };
    }
  } catch (error) {
    console.error("주문 상세 조회 중 오류:", error);
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 주문 검색 (페이지네이션)
 * @param {object} searchParams - 검색 파라미터
 * @param {number} page - 페이지 번호
 * @param {number} size - 페이지 크기
 */
export const searchOrders = async (searchParams, page = 0, size = 10) => {
  try {
    const params = new URLSearchParams();

    if (searchParams.startDate) params.append("startDate", searchParams.startDate);
    if (searchParams.endDate) params.append("endDate", searchParams.endDate);
    if (searchParams.orderState) params.append("orderState", searchParams.orderState);
    if (searchParams.creditType) params.append("creditType", searchParams.creditType);
    if (searchParams.searchTerm) {
      params.append("searchTerm", searchParams.searchTerm);
      params.append("searchType", searchParams.searchType || "all");
    }
    params.append("page", page);
    params.append("size", size);

    const response = await apiGet(`/admin/order/search?${params.toString()}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "주문 검색에 실패했습니다.",
      };
    }
  } catch (error) {
    console.error("주문 검색 중 오류:", error);
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 주문 상품 취소 처리
 * @param {number[]} orderDetailIdxList - 취소할 주문 상세 IDX 목록
 */
export const processOrderCancel = async (orderDetailIdxList) => {
  try {
    const response = await apiPut("/admin/order/cancel", {
      orderDetailIdxList,
    });

    if (response.ok) {
      const data = await response.text();
      return {
        success: true,
        data: data || "취소 처리가 완료되었습니다.",
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "취소 처리에 실패했습니다."
      };
    }
  } catch (err) {
    console.error("취소 처리 중 오류:", err);
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

